import { S3_BUCKET_URL } from '@/constants';
import { FlirtingStyleOptionIdType } from '@/pages/Onboarding/options/FlirtingStyle/types';
import { HisTypeOptionIdType } from '@/pages/Onboarding/options/HisType/types';
import { HisVoiceOptionIdType } from '@/pages/Onboarding/options/HisVoice/types';
import { HobbiesInterestsOptionIdType } from '@/pages/Onboarding/options/HobbiesInterests/types';

const HIS_TYPE_IMAGE_MAP: Record<HisTypeOptionIdType, string> = {
  twink: `${S3_BUCKET_URL}/layout-own-ai-man-main-697/twink.png`,
  daddy: `${S3_BUCKET_URL}/layout-own-ai-man-main-697/daddy.png`,
  trans: `${S3_BUCKET_URL}/layout-own-ai-man-main-697/transsexual.png`,
  otter: `${S3_BUCKET_URL}/layout-own-ai-man-main-697/otter.png`,
  queer: `${S3_BUCKET_URL}/layout-own-ai-man-main-697/queer.png`,
  leather: `${S3_BUCKET_URL}/layout-own-ai-man-main-697/leather.png`,
  boy: `${S3_BUCKET_URL}/layout-own-ai-man-main-697/twink.png`,
  pup: `${S3_BUCKET_URL}/layout-own-ai-man-main-697/pup.png`,
  clean_cut: `${S3_BUCKET_URL}/layout-own-ai-man-main-697/clean-cut.png`,
  jock_sporty: `${S3_BUCKET_URL}/layout-own-ai-man-main-697/sporty.png`,
  bear: `${S3_BUCKET_URL}/layout-own-ai-man-main-697/bear.png`,
  geek: `${S3_BUCKET_URL}/layout-own-ai-man-main-697/geek.png`,
};

interface Selections {
  his_type: HisTypeOptionIdType | null;
  his_voice: HisVoiceOptionIdType | null;
  flirting_style: FlirtingStyleOptionIdType | null;
  hobbies_interests: HobbiesInterestsOptionIdType | null;
}

export const getImageBySelection = (selections: Selections): string => {
  if (selections.his_type && HIS_TYPE_IMAGE_MAP[selections.his_type]) {
    return HIS_TYPE_IMAGE_MAP[selections.his_type];
  }

  return `${S3_BUCKET_URL}/layout-own-ai-man-main-697/photos-tile.png`;
};

export const getImageByHisType = (
  hisType: HisTypeOptionIdType | null,
): string => {
  if (hisType && HIS_TYPE_IMAGE_MAP[hisType]) {
    return HIS_TYPE_IMAGE_MAP[hisType];
  }
  return `${S3_BUCKET_URL}/layout-own-ai-man-main-697/photos-tile.png`;
};
